import React from 'react';
import { DefaultButton, Button, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType, Separator, TextField } from 'office-ui-fabric-react/lib/';
import { Stack, Checkbox } from 'office-ui-fabric-react';
import gql from 'graphql-tag';
import './ReportConfiguration.scss';
import { mergeStyleSets } from '@uifabric/merge-styles';
import UserPicker from './UserPicker';
import { MyContext } from '../../../context';
import { toast } from 'react-toastify';
import { queryGetDashboards } from '../../../queries/queryReport';

const contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: [
        {
            flex: '1 1 auto',
            borderTop: '4px solid blue',
            color: 'black',
            display: 'flex',
            fontSize: '12px',
            alignItems: 'center',
            padding: '12px 12px 14px 24px',
        },
    ],
    body: {
        flex: '4 4 auto',
        //padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0',
            },
            'p:first-child': {
                marginTop: 0,
            },
            'p:last-child': {
                marginBottom: 0,
            },
        },
    },
});




export default class DashboardConfiguration extends React.Component {

    constructor(props) {
        super(props);

        this.categoriesList = [];
        this.categoriesListSource = [];
        this.allowedTenantsList = [];
        this.dashboardConf = React.createRef();

        let dashboardUsersSource = (this.props.users === "undefined" || this.props.users == null || this.props.users == "") ? "" : this.props.users.split(',');
        let managersSource = this.props.managers ? this.props.managers.split(',') : "";
        let ownerSource = this.props.user ? this.props.user.split(',') : [];
        this.state = {
            isModalOpen: false,
            isChanged: false,
            changedTitle: props.title,
            changedType: props.type,
            tenantId: props.tenantId,
            dashboardUsers: dashboardUsersSource === "" ? [] : dashboardUsersSource.map(u => { return { userId: u } }),
            managers: managersSource ? managersSource.map(u => { return { userId: u } }) : [],
            owner: ownerSource.map(u => { return { userId: u } }),
            hasEntryListAccess: props.hasEntryListAccess,
            hasEntryListDownload: props.hasEntryListDownload
         
        };
    }


    styles = {
        root: {
            paddingTop: "20px"
        }
    };


    render() {
        return (<MyContext.Consumer>
            {(context) => (

                <div>
                    <Panel
                        isOpen={this.state.isModalOpen}
                        onDismiss={this.hidePanel}
                        titleAriaId={this._titleId}
                        subtitleAriaId={this._subtitleId}
                        headerText={this.props.title !== "" ? context.getTranslation("dashboard", "changeDashboard") : context.getTranslation("dashboard", "createDashboard")}
                        closeButtonAriaLabel="Close"
                        type={PanelType.medium}
                    >

                        <div id={this._subtitleId} className={contentStyles.body} >
                            <Stack vertical>
                                <Stack.Item>
                                    <TextField
                                        label={context.getTranslation("dashboard", "title")}
                                        value={this.props.isOwner ? this.state.changedTitle : this.props.title}
                                        disabled={!this.props.isOwner}
                                        onChange={(event, newValue) => {
                                            if (newValue == "CC")
                                                this.setState({ changedCycle: "Current" });

                                            this.setState({
                                                changedTitle: newValue
                                            });
                                        }}
                                    />
                                    {this.state.changedTitle === '' && <span style={{ color: '#b22222', fontSize: '12px' }}>Title is required</span>}

                                </Stack.Item>

                                <Stack.Item styles={{ root: { padding: '0px' } }}>
                                    <h5>{context.getTranslation("conversationsPage", "owner")}</h5>
                                    <UserPicker
                                        disabled={!(this.props.isOwner && this.props.userRules.ruleAccess.userAllowSharing)}
                                        user={this.props.isOwner ? this.state.owner : (this.props.user == "" ? "" : this.props.user.split(',').map(u => { return { userId: u } }))}
                                        fc={(user) => {
                                            this.setState({
                                                owner: user
                                            });
                                        }}

                                    />
                                    {this.state.owner.length === 0 && <span style={{ color: '#b22222', fontSize: '12px' }}>At least one owner is required</span>}

                                </Stack.Item>

                                <Stack.Item styles={{ root: { padding: '0px' } }}>
                                    <h5>{context.getTranslation("dashboard", "managers")}</h5>
                                    <UserPicker
                                        disabled={!(this.props.isOwner && this.props.userRules.ruleAccess.userAllowSharing)}
                                        user={this.props.isOwner ? this.state.managers : (this.props.managers == "" ? "" : this.props.managers.split(',').map(u => { return { userId: u } }))}
                                        fc={(user) => {
                                            this.setState({
                                                managers: user
                                            });
                                        }}
                                    />

                                </Stack.Item>

                                <Stack.Item styles={{ root: { padding: '0px' } }}>
                                    <h5>{context.getTranslation("dashboard", "viewers")}</h5>
                                    <UserPicker
                                        user={this.props.isOwner ? this.state.dashboardUsers : (this.props.users == "" ? "" : this.props.users.split(',').map(u => { return { userId: u } }))}
                                        fc={(user) => {
                                            this.setState({
                                                dashboardUsers: user
                                            });
                                        }}
                                        disabled={!(this.props.isOwner && this.props.userRules.ruleAccess.userAllowSharing)}
                                    />

                                </Stack.Item>
                                <br />

                                <Stack.Item style={{ marginBottom: "10px" }}>
                                    <Checkbox
                                        label={context.getTranslation("dashboard", "entryListAccess")}
                                        checked={this.state.hasEntryListAccess}
                                        onChange={(event, checked) => {
                                            this.setState({
                                                hasEntryListAccess: checked
                                            });
                                        }}
                                        disabled={!(this.props.isOwner && this.props.userRules.ruleAccess.userAllowSharing)}

                                    />
                                </Stack.Item>

                                <Stack.Item >
                                    <Checkbox
                                        label={context.getTranslation("dashboard", "entryListDownload")}
                                        checked={this.state.hasEntryListDownload}
                                        onChange={(event, checked) => {
                                            this.setState({
                                                hasEntryListDownload: checked
                                            });
                                        }}
                                        disabled={!(this.props.isOwner && this.props.userRules.ruleAccess.userAllowSharing)}

                                    />
                                </Stack.Item>

                            </Stack>
                            <Stack vertical horizontalAlign="center" >
                                <Separator />

                                {this.onRenderFooterContent()}

                            </Stack>

                        </div>

                    </Panel>
                </div>
            )
            }
        </MyContext.Consumer>

        );
    }


    onRenderFooterContent = () => {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <Stack horizontal horizontalAlign="center" style={{ gap: "5px" }}>

                        {this.props.isOwner && <Stack.Item>
                            <PrimaryButton onClick={this.savePanel} text={context.getTranslation("common", "save")} disabled={!this.isValid()} />
                        </Stack.Item>}
                        {!this.props.isNew && this.props.isOwner && <Stack.Item>
                            <Button onClick={this.deleteDashboard} text={context.getTranslation("common", "delete")} style={{ backgroundColor: 'red' }} />
                        </Stack.Item>}
                        {this.props.isOwner && <Stack.Item>
                            <DefaultButton onClick={this.resetState} text={context.getTranslation("common", "cancel")} />
                        </Stack.Item>}
                    </Stack>
                )
                }
            </MyContext.Consumer>
        );
    };

    isValid = () => {
        const { changedTitle, dashboardUsers, owner } = this.state;
        return (
            changedTitle?.length > 0 &&
            dashboardUsers.every(user => user.userId) &&
            owner.length > 0
        );
    }

    showModal = () => {
        this.setState({ isModalOpen: true });
    };

    hidePanel = () => {
        this.resetState();
    };


    deleteDashboard = () => {
        console.log("Dashboard id: ", this.props.id);
        this.props.apol
            .mutate({
                mutation: gql`
                mutation ent ($input: AuthInput, $id : String!) {
                    deleteDashboard (input: $input, id: $id) {
                        id
                    }
                }
            `,

                variables: { id: this.props.id, input: this.props.input },
            })
            .then((result) => {
                if (result && result.data.deleteDashboard !== null) {
                    toast.success("Dashboard deleted", {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    toast.error("Dashboard was not deleted", {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }

                this.props.reloadFuncDashboard(null);
            });
        this.hidePanel();

    }

    savePanel = () => {
        // Collect persons
        var users = "";
        if (this.state.dashboardUsers != null) {
            for (let x = 0; x < this.state.dashboardUsers.length; x++) {
                users += (x > 0 ? "," : "") + this.state.dashboardUsers[x].userId;
            }
        }
        var managers = "";
        if (this.state.managers) {
            for (let x = 0; x < this.state.managers.length; x++) {
                managers += (x > 0 ? "," : "") + this.state.managers[x].userId;
            }
        }

        var owner = "";
        if (this.state.owner) {
            for (let x = 0; x < this.state.owner.length; x++) {
                owner += (x > 0 ? "," : "") + this.state.owner[x].userId;
            }
        }


        if (!this.props.isNew) {
            this.props.apol
                .mutate({
                    mutation: gql`

                    mutation ent ($input: AuthInput, $id : String!, $title: String, $users: String, $type: String, $tenantId: String, $managers:String, $user:String, $hasEntryListAccess: Boolean, $hasEntryListDownload: Boolean) {
                        changeDashboard (input: $input, dashboard: {id: $id, title: $title, users: $users, type: $type, tenantId: $tenantId, managers:$managers, user:$user , hasEntryListAccess: $hasEntryListAccess, hasEntryListDownload: $hasEntryListDownload}) {
                            id
                        }
                    }
                `,


                    variables: {
                        input: this.props.input,
                        id: this.props.id,
                        title: this.state.changedTitle,
                        users: users,
                        tenantId: this.state.tenantId,
                        managers: managers,
                        user: owner,
                        hasEntryListAccess: this.state.hasEntryListAccess,
                        hasEntryListDownload: this.state.hasEntryListDownload,
                    },
                })
                .then((result) => {
                    if (result && result.data.changeDashboard != null) {
                        toast.success("Dashboard changed", {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    } else {
                        toast.error("Dashboard was not changed", {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }
                    this.props.reloadFuncDashboard(true);

                });
        } else {


            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent ($input: AuthInput, $id: String, $title: String, $users: String, $type: String, $tenantId: String,$managers:String, $user:String, $hasEntryListAccess: Boolean, $hasEntryListDownload: Boolean, $useStandardUserTemplate: Boolean, $useAdminUserTemplate: Boolean) {
                        createDashboard (input: $input, dashboard: {id: $id, title: $title, users: $users, type: $type, tenantId: $tenantId,managers:$managers, user:$user, hasEntryListAccess: $hasEntryListAccess, hasEntryListDownload: $hasEntryListDownload}, useStandardUserTemplate: $useStandardUserTemplate, useAdminUserTemplate:$useAdminUserTemplate) {
                            id
                        }
                    }
                `,


                    variables: {
                        input: this.props.input,
                        id: this.props.id,
                        title: this.state.changedTitle,
                        users: users,
                        tenantId: this.state.tenantId,
                        managers: managers,
                        user: owner,
                        hasEntryListAccess: this.state.hasEntryListAccess,
                        hasEntryListDownload: this.state.hasEntryListDownload,
                        useStandardUserTemplate: this.props.useStandardUserTemplate,
                        useAdminUserTemplate: this.props.useAdminUserTemplate

                    },
                })
                .then((result) => {
                    toast.success("Dashboard created", {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    this.props.reloadFuncDashboard(true);


                });
        }
        this.hidePanel();

    };

    resetState = () => {
        if (this.props.isNew) {
            let dashboardUsersSource = (this.props.users === "undefined" || this.props.users == null || this.props.users == "") ? "" : this.props.users.split(',');
            let managersSource = this.props.managers ? this.props.managers.split(',') : "";
            let ownerSource = this.props.user ? this.props.user.split(',') : [];
            
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false,
                changedTitle: this.props.title,
                changedType: this.props.type,
                tenantId: this.props.tenantId,
                dashboardUsers: dashboardUsersSource === "" ? [] : dashboardUsersSource.map(u => { return { userId: u } }),
                managers: managersSource ? managersSource.map(u => { return { userId: u } }) : [],
                owner: ownerSource.map(u => { return { userId: u } }),
                hasEntryListAccess: this.props.hasEntryListAccess,
                hasEntryListDownload: this.props.hasEntryListDownload
            });
        } else {
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false
            });
        }
    };



}
